<script lang="ts">
import { Container } from 'inversify'
import { computed, defineComponent } from 'vue'

import { StatusType } from '@collector/sportsapi-client-legacy'
import EventHeader from '@mobile/views/Relation/Shared/EventHeader/EventHeader.vue'
import Popup from '@mobile/views/Relation/Shared/Popup/Popup.vue'
import { bindSeasonParticipants } from '@mobile/views/Relation/Shared/RelationDependencies/bindSeasonParticipants'
import { bindSkins } from '@mobile/views/Relation/Shared/RelationDependencies/bindSkins'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import VerifyResults from '@mobile/views/Relation/Shared/VerifyResults/VerifyResults.vue'
import { BeachVolleyballRelationIoCBindings } from '@mobile/views/Relation/Sports/BeachVolleyball/BeachVolleyballRelationDependencies/BeachVolleyballRelationDependencies'
import { bindActiveParticipant } from '@mobile/views/Relation/Sports/BeachVolleyball/BeachVolleyballRelationDependencies/bindActiveParticipant'
import { bindAssignableIncidentConfiguration } from '@mobile/views/Relation/Sports/BeachVolleyball/BeachVolleyballRelationDependencies/bindAssignableIncidentConfiguration'
import { bindEventClockConfiguration } from '@mobile/views/Relation/Sports/BeachVolleyball/BeachVolleyballRelationDependencies/bindEventClockConfiguration'
import { bindEventHeaderConfiguration } from '@mobile/views/Relation/Sports/BeachVolleyball/BeachVolleyballRelationDependencies/bindEventHeaderConfiguration'
import { bindEventStatusesConfiguration } from '@mobile/views/Relation/Sports/BeachVolleyball/BeachVolleyballRelationDependencies/bindEventStatusesConfiguration'
import { bindEventStatusesList } from '@mobile/views/Relation/Sports/BeachVolleyball/BeachVolleyballRelationDependencies/bindEventStatusesList'
import { bindIncidentHandlersConfiguration } from '@mobile/views/Relation/Sports/BeachVolleyball/BeachVolleyballRelationDependencies/bindIncidentHandlersConfiguration'
import { bindIncidentsConfiguration } from '@mobile/views/Relation/Sports/BeachVolleyball/BeachVolleyballRelationDependencies/bindIncidentsConfiguration'
import { bindIncidentsResultConfiguration } from '@mobile/views/Relation/Sports/BeachVolleyball/BeachVolleyballRelationDependencies/bindIncidentsResultConfiguration'
import { bindLineupsConfiguration } from '@mobile/views/Relation/Sports/BeachVolleyball/BeachVolleyballRelationDependencies/bindLineupsConfiguration'
import { bindRelationHooks } from '@mobile/views/Relation/Sports/BeachVolleyball/BeachVolleyballRelationDependencies/bindRelationHooks'
import LiveView from '@mobile/views/Relation/Sports/BeachVolleyball/LiveView/LiveView.vue'

export default defineComponent({
  components: {
    VerifyResults,
    EventHeader,
    LiveView,
    Popup,
  },
  setup() {
    const { probableEvent } = useEventInjections()

    const displayVerifyResults = computed(() => {
      const probableRelationStatus = probableEvent.value?.status_type

      return probableRelationStatus === StatusType.Finished
    })

    return { displayVerifyResults }
  },
})

export function bindBeachVolleyballRelationDependencies(
  ioc: Container,
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
): Record<any, any> {
  bindEventStatusesConfiguration(ioc)
  bindIncidentHandlersConfiguration(ioc)
  bindEventStatusesList(ioc)
  bindIncidentsConfiguration(ioc)
  bindIncidentsResultConfiguration(ioc)
  bindSeasonParticipants(ioc)
  bindLineupsConfiguration(ioc)
  bindAssignableIncidentConfiguration(ioc)
  bindActiveParticipant(ioc)
  bindRelationHooks(ioc)
  bindEventHeaderConfiguration(ioc)
  bindEventClockConfiguration(ioc)

  bindSkins(ioc)

  return BeachVolleyballRelationIoCBindings
}
</script>

<template>
  <Popup />
  <EventHeader />
  <VerifyResults v-if="displayVerifyResults" />
  <LiveView />
</template>
